import { render, staticRenderFns } from "./CreateClinicCard.vue?vue&type=template&id=53d16746&"
import script from "./CreateClinicCard.vue?vue&type=script&lang=js&"
export * from "./CreateClinicCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports